import React, { useContext } from 'react';

var ThemeContext = React.createContext(null);

var ThemeProvider = function (_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'v1' : _ref$theme,
      _ref$components = _ref.components,
      components = _ref$components === void 0 ? [] : _ref$components,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: {
      theme: theme,
      components: components
    }
  }, children);
};

// Theme from component prop has higher priority

function useTheme(componentName, theme) {
  var themeContext = useContext(ThemeContext);

  if (theme) {
    return theme;
  }

  if (themeContext) {
    var themeFromContext = themeContext.theme,
        components = themeContext.components;

    if (!components.length || components.length && components.includes(componentName)) {
      return themeFromContext;
    }
  }

  return null;
}

export { ThemeProvider, useTheme };
